import { EditCustRightsComponent } from './edit-custrights/edit-custrights.component';
import { AddCustRightsComponent } from './add-custrights/add-custrights.component';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { ListCustRightsComponent } from './list-custrights/list-custrights.component';

export const routesCustRights: Routes = [
    { path: 'custrights', component: ListCustRightsComponent },
    { path: 'custrights/add', component: AddCustRightsComponent },
    { path: 'custrights/:id/edit', component: EditCustRightsComponent },
];

export const CustRightsRoutes: ModuleWithProviders = RouterModule.forChild(routesCustRights);
